import Vue from "vue";
import Router from "vue-router";
import PublicIndex from "./views/mobile/publicCourse";//公开课首页分享页

import Index2 from "./views/mobile/publicCourse/index2";//上拉刷新 下拉加载

import PublicCourse from "./views/share/publicCourse";//公开课首页
import LecturerAlbum from "./views/share/lecturerAlbum";
import AboutUs from "./views/mobile/aboutUs";
import HomePage from "./views/mobile/homePage";

import SignUpWf from "./views/mobile/weifang";//潍坊报名
import SignInWfHtml from "./views/mobile/weifangHtml";//潍坊报名

import SignUpHz from "./views/mobile/heze";//菏泽报名
import SignInHzHtml from "./views/mobile/hezeHtml";//菏泽报名

import SignUp from "./views/mobile/signUp";//赤峰报名
import SignInHtml from "./views/mobile/signInHtml";//赤峰报名

import SignUnified from "./views/mobile/unifiedRegistration";//赤峰报名
import SignUnifiedHtml from "./views/mobile/unifiedRegistrationHtml";//赤峰报名

import SignUpCj from "./views/mobile/changji";//昌吉报名
import SignInCjHtml from "./views/mobile/changjiHtml";//昌吉报名

import SignUpXy from "./views/mobile/twoTraining/shanxiXiaoyi";//山西孝义报名

// 第三方
import ThirdParty from "./views/mobile/thirdParty";
// 第三方
import LecturerPage from "./views/mobile/lecturerPage";
import UserHelpList from "./views/mobile/userHelpList";
import UserDetails from "./views/mobile/userDetails";
import UserLogout from "./views/mobile/userLogout";

// 培训等级
import TrainingRegistration from "./views/mobile/trainingRegistration";

import UserDetails1 from "./views/mobile/userDetails1";
import NewsDetails from "./views/mobile/newsDetails";
import Login from "./views/mobile/login";
import PhoneLogin from "./views/mobile/phoneLogin";
import OpenMemberLogin from "./views/mobile/openMemberLogin";
import VehicleDriverArchive from "./views/mobile/vehicleDriverArchive";


import Pay from "./views/components/pay";//支付
import PaySuccess from "./views/components/paySuccess";//支付成功
import PayFail from "./views/components/payFail";//支付失败
import FilterSystem from "./views/mobile/payment/filterSystem";//过滤子系统
import PaymentOrder from "./views/mobile/payment/paymentOrder/index";//支付订单
import PaymentOrderMember from "./views/mobile/payment/paymentOrderMember/index";//支付订单

import paymentOrderContinueEduction from "./views/mobile/payment/paymentOrderContinueEduction/index";//支付订单-针对子系统配置-教育类型“道路运输从业人员继续教育”


import PaymentResult from "./views/mobile/payment/paymentResult/index";//支付结果
import PaymentResultMember from "./views/mobile/payment/paymentResultMember/index";//支付结果

// 蒙速办
import Registration from "./views/mobile/registration";//登记与报名
import RegistrationPage from "./views/mobile/registrationPage";//报名页
import QrCode from "./views/mobile/registrationPage/qrCode";//报名页
import ToQuery from "./views/mobile/toQuery";//查询页面

import CarDetail from "./views/mobile/car/index"; //车辆基本信息

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      // path: "/",
      // name: "home",
      // component: Home
      path: "/",
		  name: "HomePage",
		  component: HomePage
    },
    { //
		  path: "/index2",
		  name: "Index2",
		  component: Index2
		},
    { //公开课分类页
		  path: "/publicCourseType",
		  name: "publicCourseType",
		  component: PublicIndex
		},
    {//公开课首页
      path: "/publicCourse",
      name: "PublicCourse",
      component: PublicCourse
    },
		{
		  path: "/lecturerAlbum",
		  name: "lecturerAlbum",
		  component: LecturerAlbum
		},
    // {
    //   path: "/about",
    //   name: "about",
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "./views/About.vue")
    // },
		{
		  path: "/aboutUs",
		  name: "AboutUs",
		  component: AboutUs
		},
      {
          path: "/signUpXy",
          name: "SignUpXy",
          component: SignUpXy
      },
		{
			path: "/signUpWf",
			name: "SignUpWf",
			component: SignUpWf
		},
		{
			path: "/signInWfHtml",
			name: "SignInWfHtml",
			component: SignInWfHtml
		},
      {
          path: "/signUpHz",
          name: "SignUpHz",
          component: SignUpHz
      },
      {
          path: "/signInHzHtml",
          name: "SignInHzHtml",
          component: SignInHzHtml
      },
	  {
		  path: "/signUp",
		  name: "SignUp",
		  component: SignUp
	  },
	  {
		  path: "/signInHtml",
		  name: "SignInHtml",
		  component: SignInHtml
	  },
		{
			path: "/signUpCj",
			name: "SignUpCj",
			component: SignUpCj
		},
		{
			path: "/signInCjHtml",
			name: "SignInCjHtml",
			component: SignInCjHtml
		},
		{
			path: "/signUnified",
			name: "SignUnified",
			component: SignUnified
		},
		{
			path: "/signUnifiedHtml",
			name: "SignUnifiedHtml",
			component: SignUnifiedHtml
		},
		{
		  path: "/homePage",
		  name: "HomePage",
		  component: HomePage
		},
	   {
		 path: "/lecturerPage",
		 name: "LecturerPage",
		 component: LecturerPage
	   },
	   {
		 path: "/userHelpList",
		 name: "UserHelpList",
		 component: UserHelpList
	   },
		 {
		   path: "/userDetails",
		   name: "UserDetails",
		   component: UserDetails
		 },
		 {
		   path: "/userLogout",
		   name: "UserLogout",
		   component: UserLogout
		 },
		 {
		   path: "/trainingRegistration",
		   name: "TrainingRegistration",
		   component: TrainingRegistration
		 },

		 {
		   path: "/userDetails1",
		   name: "UserDetails1",
		   component: UserDetails1
		 },
	{
	   path: "/newsDetails",
	   name: "NewsDetails",
	   component: NewsDetails
   },
	 {
	    path: "/paymentOrder",
	    name: "PaymentOrder",
	    component: PaymentOrder
	  },
	  {
		 path: "/paymentOrderContinueEduction",
		 name: "paymentOrderContinueEduction",
		 component: paymentOrderContinueEduction
	   },
	  {
	     path: "/paymentOrderMember",
	     name: "paymentOrderMember",
	     component: PaymentOrderMember
	   },
		{
		   path: "/paymentResult",
		   name: "PaymentResult",
		   component: PaymentResult
		 },
		 {
		    path: "/paymentResultMember",
		    name: "paymentResultMember",
		    component: PaymentResultMember
		  },
		 {
		   path: "/login",
		   name: "Login",
		   component: Login
		 },
		 {
		   path: "/phoneLogin",
		   name: "PhoneLogin",
		   component: PhoneLogin
		 },
		 {
		   path: "/openMemberLogin",
		   name: "OpenMemberLogin",
		   component: OpenMemberLogin
		 },
		 {
		   path: "/vehicleDriverArchive",
		   name: "VehicleDriverArchive",
		   component: VehicleDriverArchive
		 },
		{
			path: "/carDetail",
			name: "CarDetail",
			component: CarDetail
		},


   //支付
   { path: "/pay", name: "Pay", component: Pay },
   { path: "/paySuccess", name: "PaySuccess", component: PaySuccess },
	 { path: "/payFail", name: "PayFail", component: PayFail },
	 // 过滤子系统
	 { path: "/filterSystem", name: "FilterSystem", component: FilterSystem },
	 // 第三方
	 { path: "/thirdParty", name: "ThirdParty", component: ThirdParty },
	//  速蒙办
	{
		path: "/registration",
		name: "Registration",
		component: Registration
	  },
	  {
		path: "/registrationPage",
		name: "RegistrationPage",
		component: RegistrationPage
	  },
	  {
		path: "/toQuery",
		name: "ToQuery",
		component: ToQuery
	  },
	  {
		path: "/qrCode",
		name: "QrCode",
		component: QrCode
	  },



  ]
});
